import { useEffect, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { adminApi } from "../../dataProvider";

type Wallet = { id: string; address: string };

export function ShowKeyDialog({ wallet, onClose }: { wallet: Wallet; onClose: () => void }) {
  const [key, setKey] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [reveal, setReveal] = useState(false);

  useEffect(() => {
    adminApi<{ private_key_hex: string }>(`/admin/wallets/${wallet.id}/show-key`, { method: "POST" })
      .then((d) => setKey(d.private_key_hex))
      .catch((e) => setErr(String(e)));
  }, [wallet.id]);

  const copy = async () => {
    if (!key) return;
    try {
      await navigator.clipboard.writeText(key);
    } catch {
      /* ignore */
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Приватный ключ</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Alert severity="warning">
            Этот ключ даёт полный доступ к балансу. Не пересылайте никому, не вставляйте в чаты.
            Просмотр залогирован в audit_log.
          </Alert>
          <Typography variant="caption">Адрес: <b>{wallet.address}</b></Typography>
          {err && <Alert severity="error">{err}</Alert>}
          {key && (
            <TextField
              value={reveal ? key : "•".repeat(key.length)}
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
                sx: { fontFamily: "monospace", fontSize: 13 },
                endAdornment: (
                  <Stack direction="row">
                    <Tooltip title={reveal ? "Скрыть" : "Показать"}>
                      <IconButton size="small" onClick={() => setReveal((r) => !r)}>
                        {reveal ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Скопировать">
                      <IconButton size="small" onClick={copy}>
                        <ContentCopyIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                ),
              }}
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Закрыть</Button>
      </DialogActions>
    </Dialog>
  );
}
